/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { i as initialize } from './ionic-global-CTSyufhF.js';

const globalScripts = initialize;

export { globalScripts as g };
